(() => {
  const init = (root = document) => root.querySelectorAll('[data-drx-library]').forEach(library => {
    if (library.dataset.ready) return;
    library.dataset.ready = 'true';
    const cards = [...library.querySelectorAll('[data-album-category]')];
    const filters = [...library.querySelectorAll('[data-gallery-filter]')];
    filters.forEach(button => {
      const key = button.dataset.galleryFilter;
      if (key !== 'all' && !cards.some(c => c.dataset.albumCategory === key)) button.hidden = true;
      button.addEventListener('click', () => {
        filters.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        cards.forEach(c => c.hidden = key !== 'all' && c.dataset.albumCategory !== key);
      });
    });
    const requested = new URLSearchParams(location.search).get('category');
    const matched = filters.find(button => button.dataset.galleryFilter === requested && !button.hidden);
    if (matched) matched.click();
    const dialog = library.querySelector('dialog');
    const image = dialog.querySelector('[data-viewer-image]');
    const thumbs = dialog.querySelector('[data-viewer-thumbs]');
    let photos = [], index = 0, opener, previousOverflow;
    const show = next => {
      index = (next + photos.length) % photos.length;
      const photo = photos[index]; image.src = photo.src; image.alt = photo.alt;
      dialog.querySelector('[data-viewer-count]').textContent = `${index + 1} / ${photos.length}`;
      [...thumbs.children].forEach((b,i) => b.setAttribute('aria-current', String(i === index)));
      thumbs.children[index]?.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
      dialog.querySelector('[data-viewer-prev]').disabled = photos.length < 2;
      dialog.querySelector('[data-viewer-next]').disabled = photos.length < 2;
    };
    cards.forEach(card => card.querySelector('button').addEventListener('click', event => {
      opener = event.currentTarget;
      photos = JSON.parse(card.querySelector('[data-album-photos]').textContent);
      dialog.querySelector('[data-viewer-title]').textContent = card.dataset.albumTitle;
      thumbs.replaceChildren(...photos.map((p,i) => {
        const b = document.createElement('button'); b.type='button'; b.setAttribute('aria-label',p.alt);
        const img = document.createElement('img'); img.src=p.thumb; img.alt=''; img.loading='lazy'; img.width=62; img.height=58;
        b.append(img); b.addEventListener('click',()=>show(i)); return b;
      }));
      previousOverflow=document.documentElement.style.overflow;
      document.documentElement.style.overflow='hidden'; dialog.showModal(); show(0);
      dialog.querySelector('[data-viewer-close]').focus();
    }));
    dialog.querySelector('[data-viewer-close]').addEventListener('click',()=>dialog.close());
    dialog.querySelector('[data-viewer-prev]').addEventListener('click',()=>show(index-1));
    dialog.querySelector('[data-viewer-next]').addEventListener('click',()=>show(index+1));
    dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){event.preventDefault();show(index+1)}if(event.key==='ArrowLeft'){event.preventDefault();show(index-1)}});
    dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;opener?.focus()});
    let touchX=null;
    image.addEventListener('touchstart',e=>touchX=e.touches[0].clientX,{passive:true});
    image.addEventListener('touchend',e=>{if(touchX!==null){const delta=e.changedTouches[0].clientX-touchX;if(Math.abs(delta)>50)show(index+(delta<0?1:-1));touchX=null}},{passive:true});
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();

